export const randomColors = [
  '#FFF3B0',
  '#B2BD7E',
  '#7FC6A4',
  '#FAF33E',
  '#EEF5DB',
  '#FE5F55',
  '#AFBBF2',
  '#61C9A8',
  '#ED9B40',
];
